const ONBOARDING_RUNTIME_MARKER_PATTERN =
	/(?:\bon[-\s]?api\b.{0,80}\b(?:source|website)\s+analysis\b|\b(?:source|website)\s+analysis\s+(?:provider|url|title)\b|\bapify(?:\s+api)?\s+v?\d+(?:\s+actor)?\b|\bactor\s*:\s*[a-z0-9_./-]+\b|\bsocial\s+type\s*:\s*[a-z0-9_-]+\b)/iu;

/** Remove provider/runtime metadata from persisted onboarding facts before projection. */
export const sanitizeOnboardingRuntimeMarker = (value: string): string => {
	const text = value.replace(/\s+/g, ' ').trim();
	const marker = ONBOARDING_RUNTIME_MARKER_PATTERN.exec(text);
	if (!marker || marker.index === undefined) return text;
	return text.slice(0, marker.index).replace(/[\s\-—:;,]+$/u, '').trim();
};

export const containsOnboardingRuntimeMarker = (value: string): boolean =>
	ONBOARDING_RUNTIME_MARKER_PATTERN.test(value);
